<template>
	<div>
		<CommonFlame :title="title" class="mt-2">
			<template v-if="!$vuetify.breakpoint.xs && authorized" v-slot:app-bar-btn>
				<v-btn color="primary" @click="redirectToNewPage" dark
					><v-icon>mdi-plus</v-icon>部品見積依頼作成</v-btn
				>
				<v-menu ref="menu" offset-y :close-on-content-click="false">
					<template v-slot:activator="{ on, attrs }">
						<v-btn color="primary" dark v-bind="attrs" v-on="on">
							<v-icon class="mr-2">mdi-magnify</v-icon>検索
						</v-btn>
					</template>
					<v-card width="300px">
						<v-app-bar dense color="primary" flat>
							<v-app-bar-title class="color-white text-body-1 font-weight-bold"
								>絞り込み検索</v-app-bar-title
							>
						</v-app-bar>
						<v-card-text class="pa-2">
							<v-form ref="search_form" @submit.prevent="search(1)">
								<v-radio-group
									v-model="q.component_quotes_quotation_type_cont"
									row
									hide-details="false"
								>
									<v-radio label="受注" value="ordered"></v-radio>
									<v-radio label="未受注" value="yet"></v-radio>
								</v-radio-group>
								<v-text-field
									v-model.trim="q.component_quotes_ordered_product_product_number_cont"
									label="製造番号"
									hint="製造番号を入力してください"
									class="mt-4"
									outlined
									dense
								></v-text-field>

								<v-row class="mt-4" no-gutters justify="center">
									<v-btn color="secondary" outlined @click.prevent="search(1)" class="mr-2">
										<v-icon class="mr-2">mdi-magnify</v-icon>
										検索する</v-btn
									>
									<v-btn color="secondary" outlined @click="resetForm"> クリア</v-btn>
								</v-row>
							</v-form>
						</v-card-text>
					</v-card>
				</v-menu>
			</template>
			<template v-if="$vuetify.breakpoint.xs && authorized">
				<v-btn color="secondary" class="ml-2 my-2" @click="redirectToNewPage">
					<v-icon class="mr-1">mdi-plus</v-icon>
					部品見積作成
				</v-btn>
				<v-menu offset-y :close-on-content-click="false">
					<template v-slot:activator="{ on, attrs }">
						<v-btn color="secondary" dark v-bind="attrs" v-on="on">
							<v-icon class="mr-2">mdi-magnify</v-icon>検索
						</v-btn>
					</template>
					<v-card width="300px">
						<v-app-bar dense color="primary" flat>
							<v-app-bar-title class="color-white text-body-1 font-weight-bold"
								>絞り込み検索</v-app-bar-title
							>
						</v-app-bar>
						<v-card-text class="pa-2">
							<v-form ref="search_form">
								<v-radio-group
									v-model="q.component_quotes_quotation_type_cont"
									row
									hide-details="false"
								>
									<v-radio label="受注" value="ordered"></v-radio>
									<v-radio label="未受注" value="yet"></v-radio>
								</v-radio-group>
								<v-text-field
									v-model.trim="q.component_quotes_ordered_product_product_number_cont"
									label="製造番号"
									hint="製造番号を入力してください"
									class="mt-4"
									outlined
									dense
								></v-text-field>

								<v-row class="mt-4" no-gutters justify="center">
									<v-btn color="secondary" outlined @click.prevent="search(1)" class="mr-2">
										<v-icon class="mr-2">mdi-magnify</v-icon>
										検索する</v-btn
									>
									<v-btn color="secondary" outlined @click="resetForm"> クリア</v-btn>
								</v-row>
							</v-form>
						</v-card-text>
					</v-card>
				</v-menu>
			</template>
			<div class="table-container px-2">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="items"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr @click="openShowDialog(item)">
							<td>
								<span v-if="item.component_quotes.length">
									{{ item.component_quotes[0].quotation_type | quotationTypeFormatter }}
								</span>
							</td>
							<td>{{ item.quote_number }}</td>
							<td>{{ item.supplier.name }}</td>
							<td>{{ item.created_at | datetimeFormatter }}</td>
							<td>{{ item.user.full_name }}</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
			<ComponentQuotesShowDialog
				v-if="quote_request"
				:quote_request="quote_request"
				@close="quote_request = null"
			/>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import Qs from "qs"

import CommonFlame from "../shared/CommonFlame.vue"
import errorHandling from "../../helper/errorHandling"
import authenticate from "../../helper/authenticate"
import PaginationModule from "../../modules/PaginationModule.vue"
import moment from "moment/min/moment.min.js"
import ComponentQuotesShowDialog from "./components/ComponentQuotesShowDialog.vue"
import common from "../../helper/common"

export default {
	filters: {
		datetimeFormatter(date) {
			if (date) {
				return moment(date).format("YYYY/MM/DD HH:mm")
			}
		},
		quotationTypeFormatter(item) {
			switch (item) {
				case "ordered":
					return "受注"
					break
				case "yet":
					return "未受注"
					break
			}
		},
	},
	components: {
		CommonFlame,
		PaginationModule,
		ComponentQuotesShowDialog,
	},
	data() {
		return {
			title: "部品見積依頼",
			headers: [
				{ text: "見積種類", value: "quotation_type", width: "100px" },
				{ text: "見積番号", value: "quote_number", width: "100px" },
				{ text: "送信先企業", value: "supplier.name", width: "120px" },
				{ text: "送信日時", value: "component_quote.created_at", width: "100px" },
				{ text: "送信者", value: "", width: "100px" },
				// { text: "回答日", value: "", width: "100px" },
			],
			items: [],
			authorized: false,
			newDialog: false,
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			quote_request: null,
			q: {
				component_quotes_quotation_type_cont: null,
				component_quotes_ordered_product_product_number_cont: null,
			},
		}
	},
	mounted() {
		const page = this.$route.query.page ? this.$route.query.page : 1
		this.setQuery()

		if (
			common.isPresence(this.q.component_quotes_quotation_type_cont) ||
			common.isPresence(this.q.component_quotes_ordered_product_product_number_cont)
		) {
			this.search(page)
		} else {
			this.fetchComponentQuotes(page)
		}
	},

	methods: {
		search(page) {
			const params = { q: this.q, page }
			const paramsSerializer = (params) => Qs.stringify(params, { arrayFormat: "brackets" })

			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/search_component_quotes", {
					headers,
					params,
					paramsSerializer,
				})
				.then((res) => {
					this.items = res.data.quote_requests
					this.pagination = res.data.pagination
					this.authorized = res.data.authorized
					this.$router.push({
						name: "component_quotes_index",
						query: { ...this.q, page: page },
					})
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
				.finally(() => {
					this.$refs.menu.isActive = false
				})
		},
		setQuery() {
			const query = this.$route.query
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page") {
					this.q[query_key] = this.formatQuery(query[query_key])
				}
			})
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
		resetForm() {
			this.$refs.search_form.reset()
		},
		fetchComponentQuotes(page) {
			const params = { page }

			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/component_quotes", {
					params,
					headers,
				})
				.then((res) => {
					this.items = res.data.quote_requests
					this.pagination = res.data.pagination
					this.authorized = res.data.authorized
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		redirectToNewPage() {
			this.$router.push({ name: "component_quotes_new" })
		},
		// getPage(page) {
		// 	this.fetchComponentQuotes(page)
		// 	this.$router.push({
		// 		name: "component_quotes_index",
		// 		query: { page: page },
		// 	})
		// 	window.scrollTo({
		// 		top: 0,
		// 		behavior: "smooth",
		// 	})
		// },
		getPage(page) {
			if (
				common.isPresence(this.q.component_quotes_quotation_type_cont) ||
				common.isPresence(this.q.component_quotes_ordered_product_product_number_cont)
			) {
				this.search(page)
			} else {
				this.fetchComponentQuotes(page)
				this.$router.push({
					name: "component_quotes_index",
					query: { page: page },
				})
				window.scrollTo({
					top: 0,
					behavior: "smooth",
				})
			}
		},
		openShowDialog(item) {
			this.quote_request = item
		},
	},
}
</script>
